import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-dailogs',
  templateUrl: './ui-dailogs.component.html',
  styleUrls: ['./ui-dailogs.component.scss']
})
export class UiDailogsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
